
import ContactForm from "@/components/ContactForm";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const Contact = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: "Visit Us",
      details: ["123 Business Avenue", "New York, NY 10001", "United States"]
    },
    {
      icon: Phone,
      title: "Call Us",
      details: ["+1 (234) 567-890", "+1 (234) 567-891"]
    },
    {
      icon: Mail,
      title: "Email Us",
      details: ["info@sslsol.com", "support@sslsol.com"]
    },
    {
      icon: Clock,
      title: "Business Hours",
      details: ["Monday - Friday: 9:00 AM - 6:00 PM", "Saturday: 10:00 AM - 2:00 PM"]
    }
  ];

  return (
    <div className="min-h-screen py-12 bg-gradient-to-b from-indigo-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-800 dark:text-white text-center mb-6">Contact Us</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 text-center max-w-3xl mx-auto mb-12">
          Get in touch with us to discuss how we can help transform your business.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              {contactInfo.map((info, index) => (
                <Card key={index} className="curved-xl shadow-soft border border-gray-100 dark:border-gray-700">
                  <CardContent className="p-6">
                    <div className="flex flex-col items-center text-center">
                      <div className="p-3 bg-indigo-100 dark:bg-indigo-900 rounded-full mb-4">
                        <info.icon className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
                      </div>
                      <h3 className="font-semibold mb-2 text-gray-800 dark:text-white">{info.title}</h3>
                      {info.details.map((detail, idx) => (
                        <p key={idx} className="text-gray-600 dark:text-gray-300">
                          {detail}
                        </p>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
          <div className="curved-xl bg-white dark:bg-gray-800 shadow-soft p-6 border border-gray-100 dark:border-gray-700">
            <ContactForm />
          </div>
        </div>

        {/* Map Section */}
        <div className="w-full h-[400px] bg-white dark:bg-gray-800 curved-xl flex items-center justify-center shadow-soft border border-gray-100 dark:border-gray-700">
          <p className="text-gray-600 dark:text-gray-300">Map Integration Coming Soon</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
